export function  formatDate(value){
    if(value){
    const dateNo = new Date(value)
    return dateNo.getDate()+"/"+(dateNo.getMonth()+1)+"/"+dateNo.getFullYear()
    } else {
    return ""
    }
}

export const countTodayValues = (array) => {
    const today = new Date();
    const todayString = today.toISOString().split('T')[0]; 
    const todayValues = array.filter(obj => {
        const createdAtDate = new Date(obj.createdAt);
        const createdAtString = createdAtDate.toISOString().split('T')[0];
        return createdAtString === todayString;
    });
    return todayValues.length;
}

export const  countYesterdayValues = (array) => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1); // Set yesterday's date
    
    const yesterdayString = yesterday.toISOString().split('T')[0]; // Convert yesterday's date to string
    
    const yesterdayValues = array.filter(obj => {
        const createdAtDate = new Date(obj.createdAt);
        const createdAtString = createdAtDate.toISOString().split('T')[0];
        return createdAtString === yesterdayString;
    });
    return yesterdayValues.length;
}


export const countThisMonthValues = (array) => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // January is 0, December is 11

    const thisMonthValues = array.filter(obj => {
        const createdAtDate = new Date(obj.createdAt);
        return createdAtDate.getFullYear() === currentYear && createdAtDate.getMonth() === currentMonth;
    });

    return thisMonthValues.length;
}


export const  countLastMonthValues = (array) => {
    const today = new Date();
    const lastMonth = new Date(today);
    lastMonth.setMonth(today.getMonth() - 1); // Set last month's date
    const lastMonthStartDate = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1); // First day of last month
    const lastMonthEndDate = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of last month
    const valuesLastMonth = array.filter(obj => {
        const createdAtDate = new Date(obj.createdAt);
        return createdAtDate >= lastMonthStartDate && createdAtDate <= lastMonthEndDate;
    });
    return valuesLastMonth.length;
}

export const calculateRate = (currentValue, previousValue) => {
    if(currentValue-previousValue == 0)
      return 0
    else
      return ((currentValue-previousValue)*100)/currentValue
}





